<template>
  <div class="cd_address">
    <ul>
      <li>
        <h2>{{header}}</h2>
      </li>
      <li>
        <font-awesome-icon icon="envelope" color="white"/> <a :href="'mailto:'+email">{{email}}</a>
      </li>
      <li>
        <font-awesome-icon icon="phone" color="white"/> {{phone}}
      </li>
      <li>
        <font-awesome-icon icon="map-marker" color="white"/> {{address}}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'FooterAddress',
    props: {
      email: String,
      phone: String,
      address: String,
      header: String
    }
  }
</script>
